import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c4776096&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c4776096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4776096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4776096')) {
      api.createRecord('c4776096', component.options)
    } else {
      api.reload('c4776096', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c4776096&scoped=true&", function () {
      api.rerender('c4776096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24K9VcD1MHU5H/JS/comp/GuestBox.vue"
export default component.exports